
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { AboutDialogComponent } from '../about-dialog/about-dialog.component';
import { NotificationPreferencesDialogComponent } from '../notification-preferences-dialog/notification-preferences-dialog.component';
import { MessagesDialogComponent } from '../messages-dialog/messages-dialog.component';

@Component({
  selector: 'app-header',
  imports: [
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatButtonModule,
    MatDialogModule,
    MatBadgeModule,
    RouterModule
],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  @Input() title: string = '';
  public showHome: boolean = false;
  public showAdmin: boolean = false;
  public unreadMessageCount: number = 0; // TODO: Load from API

  constructor(private router: Router,
    private auth: AuthenticationService,
    private dialog: MatDialog) {
    this.router.events.subscribe((event) => {
      // Logic to handle route changes if needed
      if (event instanceof NavigationEnd) {
        this.showHome = event.urlAfterRedirects.indexOf('/admin') !== -1;
        console.log('Route changed:', event);
      }

    });

    this.auth.currentUser.subscribe(async user => {
      this.showAdmin = user?.isAdmin ?? false;
    });
  }

  public onLogoutClicked(): void {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  public onAboutClicked(): void {
    this.dialog.open(AboutDialogComponent, {
      width: '400px'
    });
  }

  public onNotificationsClicked(): void {
    const dialogRef = this.dialog.open(NotificationPreferencesDialogComponent, {
      width: '700px',
      maxWidth: '90vw'
    });

    dialogRef.afterClosed().subscribe(preferences => {
      if (preferences) {
        console.log('Notification preferences saved:', preferences);
        // TODO: Send preferences to API
      }
    });
  }

  public onMessagesClicked(): void {
    const dialogRef = this.dialog.open(MessagesDialogComponent, {
      width: '800px',
      maxWidth: '90vw'
    });

    dialogRef.afterClosed().subscribe(unreadCount => {
      if (unreadCount !== undefined) {
        this.unreadMessageCount = unreadCount;
      }
    });
  }
}
